// credit notes
const CreditNoteIndex = () => import("./credit-notes/index.vue");
// const CreateCreditNoteDocument = () => import("./credit-notes/_pages/create.vue");
const CreditNoteDocumentCreate = () => import("./credit-notes/_pages/view.vue");
const SaleReturnDetails = () => import("./credit-notes/_pages/return-details.vue");

// Debit Note
const DebitNoteIndex = () => import("./debit-notes/index.vue");
const CreateDebitNote = () => import("./debit-notes/_pages/create.vue");
const DebitNoteCreate = () => import("./debit-notes/_pages/view.vue");
const PurchaseReturnDetails = () => import("./debit-notes/_pages/return-details.vue");

export default [
    {
        path: "/credit-notes",
        component: CreditNoteIndex,
      },
      {
        path: "/credit-notes/:id",
        component: CreditNoteDocumentCreate,
      },
      {
        path: "/sale-return-details/:id",
        component: SaleReturnDetails,
      },
      {
        path: "/debit-notes",
        component: DebitNoteIndex,
      },
      {
        path: "/new-debit-note",
        component: CreateDebitNote,
      },
      {
        path: "/debit-notes/:id",
        component: DebitNoteCreate,
      },
      {
        path: "/purchase-return-details/:id",
        component: PurchaseReturnDetails,
      },
];